var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-with-top-bar"},[_c('cad-studio',{ref:"refCadStudio",attrs:{"entity-id":_vm.projectId,"type-pictogram":_vm.typePictogram,"can-actions-pictogram":_vm.canActionsPictogram},on:{"epc-reload":() => { _vm.$emit('epc-reload') }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }